<template>
<modal :value="value" @input="$emit('input', $events)">
<div>
  <div class="top">
    PDF Preview <a id="link">l</a>
  </div>

  <div ref="container" class="container">
    <div v-if="loading" style="position:absolute;z-index:2000;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:center;background-color:white">
      <div style="font-size:60px;">
        <i class="el-icon-loading"></i>
      </div>
    </div>

    <div ref="content" class="content">
      <div class="page">
        <div class="chart-title">
          Targets
        </div>
        <pi-chart ref="targetChart"></pi-chart>
      </div>

      <div class="page">
        <div class="chart-title">
          Target Species
        </div>
        <pi-chart ref="organismChart"></pi-chart>
      </div>

      <template v-for="(target, id, i) in targets">
        <div class="page" :key="i">
          <div style="margin:5px 0px">
            <span class="target-name" style="font-size:20px;font-weight:600">{{target[0].pref_name}}</span>
          </div>

          <div style="margin-bottom:8px">
            <b>ID</b>: {{id}}
          </div>

          <div style="margin-bottom:8px">
            <b>Type</b>: {{target[0].type}}
          </div>

          <div style="margin-bottom:8px">
            <b>Organism</b>: {{target[0].organism}}
          </div>

          <div v-if="id in functions" style="margin-bottom:8px">
            <div><b>Involved Functions</b></div>
            <div class="items">
              <div v-for="(func, ifunc) in functions[id].slice(0, 20)" class="item" :key="ifunc">
                {{func.name}}
              </div>
            </div>
          </div>

          <div v-if="id in processes" style="margin-bottom:8px">
            <div><b>Involved Processes</b></div>
            <div class="items">
              <div v-for="(proc, iproc) in processes[id].slice(0, 20)" class="item" :key="iproc">
                {{proc.name}}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

  <div class="bottom">
    <div style="margin-right:10px;cursor:pointer" @click="prevPage" class="noselect">
      Prev
    </div>

    <div>
      {{page}}/{{pages}}
    </div>

    <div style="margin-left:10px;cursor:pointer" @click="nextPage" class="noselect">
      Next
    </div>

    <div class="download-container">
      <div class="download-button" @click="save">
        Download
      </div>
    </div>
  </div>
</div>
</modal>
</template>

<script>
import JsPDF from 'jspdf'
import html2pdf from 'html2pdf.js'
import PiChart from './PiChart.vue'
import utils from '../utils.js'
import html2canvas from 'html2canvas'
import Modal from './Modal'

export default {
  name: 'Pdf',

  data () {
    return {
      targets: [],
      targetNames: [],
      targetSpecies: [],
      functions: [],
      processes: [],
      page: 1,
      pages: 1,
      loading: false
    }
  },

  props: [ 'value' ],

  components: {
    PiChart, Modal
  },

  methods: {
    ...utils.mapUtils([
      //
    ]),

    nextPage () {
      if (this.page < this.pages) {
        this.page += 1
        this.updatePage()
      }
    },

    prevPage () {
      if (this.page > 1) {
        this.page -= 1
        this.updatePage()
      }
    },

    updatePage () {
      this.$refs.container.scrollTop = (this.page - 1) * this.$refs.container.offsetHeight
    },

    update (compounds) {
      let v = this

      v.targets = utils.getTargets(compounds)
      console.log(v.targets)
      v.targetNames = utils.getTargetNames(compounds).slice(0, 10)
      v.targetSpecies = utils.getTargetSpecies(compounds).slice(0, 10)
      v.functions = utils.targetFunctionMap(compounds)
      v.processes = utils.targetProcessMap(compounds)

      v.pages = 2 + Object.keys(v.targets).length

      let colors = ['#641e16', '#d35400', '#117a65', '#1b4f72', '#4a235a', '#273746', '#707b7c', '#f4d03f', '#73c6b6', '#5499c7']
      v.$refs.targetChart.update(v.targetNames.map(n => n.num), colors, v.targetNames.map(n => n.name))
      v.$refs.organismChart.update(v.targetSpecies.map(n => n.num), colors, v.targetSpecies.map(n => n.organism))
    },

    save () {
//      html2pdf(this.$refs.content, {margin: 1, jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }, image: {type: 'jpeg', quality: 0.95}, filename: `Report.pdf`})
      let v = this

//      var element = this.$refs.content
//      var opt = {
//        margin: 1,
//        filename: 'myfile.pdf',
//        image: { type: 'jpeg', quality: 0.98 },
//        html2canvas: { scale: 2 },
//        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//      }
//
//      html2pdf().set(opt).from(element).save('Report.pdf')

//      window.html2canvas = html2canvas
//      html2canvas(this.$refs.content).then(function (canvas) {
//        let link = document.getElementById('link')
//        link.setAttribute('download', 'Report.png')
//        link.setAttribute('href', canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'))
//        link.click()
//        v.loading = false
//      })

//      v.loading = true
//      let doc = new JsPDF('p', 'mm', [1000, 1500])
//      doc.html(this.$refs.content, {
//        html2canvas: {
//          width: 1000
//        },
//
//        callback: function (doc) {
//          doc.save()
//          v.loading = false
//        }
//      })

      let doc = new JsPDF()
      doc.setTextColor('#444444')

      doc.setFontSize(20)
      doc.text('Targets', 105, 40, { align: 'center' })
      doc.addImage(v.$refs.targetChart.img(), 'PNG', 10, 65, 200, 100)

      doc.addPage()
      doc.setFontSize(20)
      doc.text('Target Species', 105, 40, { align: 'center' })
      doc.addImage(v.$refs.organismChart.img(), 'PNG', 10, 65, 200, 100)

      for (let id of Object.keys(v.targets)) {
        let target = v.targets[id]
        doc.addPage()
        let lineHeight = 7
        let y = 40
        doc.setFontSize(20)
        doc.text(target[0].pref_name, 105, y, { align: 'center' })
        doc.setFontSize(12)
        y += 20
        doc.text(`ID: ${id}`, 20, y)

        y += lineHeight * 1.5
        doc.text(`Type: ${target[0].type}`, 20, y)

        y += lineHeight * 1.5
        doc.text(`Organism: ${target[0].organism}`, 20, y)

        if (id in v.functions) {
          y += lineHeight * 1.5
          doc.text('Involved Functions:', 20, y)
          let functions = v.functions[id].slice(0, 20).map(func => func.name).join('     ')
          let lines = doc.splitTextToSize(functions, 150)
          for (let i = 0; i < lines.length; i++) {
            y += lineHeight
            doc.text(lines[i], 20, y)
          }
        }

        if (id in v.processes) {
          y += lineHeight * 1.5
          doc.text('Involved Functions:', 20, y)
          let processes = v.processes[id].slice(0, 20).map(proc => proc.name).join('     ')
          let lines = doc.splitTextToSize(processes, 150)
          for (let i = 0; i < lines.length; i++) {
            y += lineHeight
            doc.text(lines[i], 20, y)
          }
        }
      }
      doc.save('Report.pdf')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";


$pageWidth: 500px;
$pageHeight: 700px;

.top {
  background-color: #aaaaaa;
  color: white;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  font-weight: 550;
}

.bottom {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #eeeeee;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 550;
}

.download-container {
  position: absolute;
  right: 4px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}

.download-button {
  border-radius: 4px;
  background-color: $theme-color;
  color: white;
  line-height: 25px;
  height: 25px;
  padding: 3px 10px;
  cursor: pointer;
  font-size: 15px;
}

.download-button:hover {
  opacity: 0.5;
}

.container {
  width: $pageWidth;
  height: $pageHeight;
  overflow-y: hidden;
  position: relative;
  /*
  overflow-y: scroll;
  */
}

.content {
  width: $pageWidth;
}

.page {
  width: $pageWidth;
  height: $pageHeight;
  padding: 10px 20px;
  box-sizing: border-box;
  overflow-y: hidden;
}

.chart-title {
  font-size:30px;
  font-weight:600;
  color:#888888;
  margin:20px;
  text-align:center;
}

.items {
  float: left;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.item {
  margin: 0px 8px;
  font-size: 13px;
  font-weight: 450;
}

</style>
